import { Anchor, Button, Divider, Flex, Stack, Text } from '@mantine/core';
import { IconBrandTelegram, IconBrandWhatsapp } from '@tabler/icons-react';
import React from 'react';

import { IContact } from 'entities/Team/types';
import { useContacts } from 'hooks/useContacts';

import s from './ContactsModal.module.scss';

type Props = {
  contacts: IContact[];
};

const ContactsModal: React.FC<Props> = ({ contacts }) => {
  const { contactsByChannel, links, texts, hasMessengers, hasDirectContacts } = useContacts(contacts);

  const { phone, email, telegram, whatsapp } = contactsByChannel;
  const { phone: phoneLink, email: emailLink, telegram: telegramLink, whatsapp: whatsappLink } = links;
  const { phone: phoneText, email: emailText } = texts;

  return (
    <Stack gap="md" align="center">
      {hasDirectContacts && (
        <Stack gap="md" w="100%">
          {phone && (
            <Stack gap="xxxs" align="center">
              <Text size="sm" c="gray.6">
                Телефон
              </Text>
              {phoneLink ? (
                <Anchor href={phoneLink.href} target={phoneLink.target} rel={phoneLink.rel} className={s.contactLink}>
                  <Text size="sm" fw={400}>
                    {phoneText}
                  </Text>
                </Anchor>
              ) : (
                <Text size="sm" fw={400}>
                  {phoneText}
                </Text>
              )}
            </Stack>
          )}

          {email && (
            <Stack gap="xxxs" align="center">
              <Text size="sm" c="gray.6">
                Email
              </Text>
              {emailLink ? (
                <Anchor href={emailLink.href} target={emailLink.target} rel={emailLink.rel} className={s.contactLink}>
                  <Text size="sm" fw={400}>
                    {emailText}
                  </Text>
                </Anchor>
              ) : (
                <Text size="sm" fw={400}>
                  {emailText}
                </Text>
              )}
            </Stack>
          )}
        </Stack>
      )}

      {hasDirectContacts && hasMessengers && (
        <Divider
          label={
            <Text size="sm" c="gray.6">
              Или
            </Text>
          }
          labelPosition="center"
          w="100%"
          my="xxxs"
        />
      )}

      {hasMessengers && (
        <Flex gap="md" w="100%">
          {telegram && telegramLink && (
            <Button
              variant="light"
              size="sm"
              color="indigo"
              leftSection={<IconBrandTelegram size={16} />}
              component="a"
              href={telegramLink.href}
              target={telegramLink.target}
              rel={telegramLink.rel}
              className={s.messengerButton}
              fullWidth
            >
              <Text fw={400} size="sm">
                Telegram
              </Text>
            </Button>
          )}

          {whatsapp && whatsappLink && (
            <Button
              variant="light"
              color="green"
              size="sm"
              leftSection={<IconBrandWhatsapp size={16} />}
              component="a"
              href={whatsappLink.href}
              target={whatsappLink.target}
              rel={whatsappLink.rel}
              className={s.messengerButton}
              fullWidth
            >
              <Text fw={400} size="sm">
                WhatsApp
              </Text>
            </Button>
          )}
        </Flex>
      )}
    </Stack>
  );
};

export default ContactsModal;
